import { useDraftReturn } from "./use-draft-return";
import { useReturnReasons } from "./use-return-reasons";
import { usePublicOrder } from "../queries/use-public-order";

/**
 * Returns true when reshipping must be paid — §14:
 * 1. `order.opt.reshippingHasToBePaid === true`
 * 2. No draft item has a reason with `skipReshipping === true`
 * 3. Draft contains an exchange item, OR an exchange-credit item with rebuy items
 */
export function useShouldPayReshipping(orderId: string, shopId: string): boolean {
  const { data: order } = usePublicOrder(orderId);
  const draft = useDraftReturn(orderId);
  const reasons = useReturnReasons(shopId);

  const reshippingHasToBePaid = (order as any)?.opt?.reshippingHasToBePaid === true;

  const reasonMap = new Map(reasons.map((r) => [r.id, r]));
  const hasSkipReshipping = draft?.lineItems.some(
    (li) => li.reasonId != null && reasonMap.get(li.reasonId)?.skipReshipping === true,
  ) ?? false;
  const hasExchange = draft?.lineItems.some((li) => li.resolution === "exchange") ?? false;
  const hasExchangeCredit = draft?.lineItems.some((li) => li.resolution === "exchange-credit") ?? false;
  const hasRebuy = (draft?.rebuyItems?.length ?? 0) > 0;

  if (!reshippingHasToBePaid || !draft) return false;
  if (hasSkipReshipping) return false;

  return hasExchange || (hasExchangeCredit && hasRebuy);
}
